import axios from 'axios';


const url = process.env.REACT_APP_BACKEND_URL;
// const url='http://192.168.100.181:5000'
// const url2=process.env.REACT_APP_BASE_URL

export const getAgentList=async(type,setData)=>{
    try {
        await axios.post(`${url}/map/get_agent_list`,{"mapped_type": type})
       .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })   
    } catch (error) {
        console.log(error);
    }
}

export const getDsList=async(type,category,setData)=>{
    try {
        await axios.post(`${url}/map/get_ds_list`,{"mapped_type": type,"mapped_category":category})
       .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })
        
    } catch (error) {
        console.log(error);
    }
}

export const getTmList=async(type,category,setData)=>{
    try {
        await axios.post(`${url}/map/get_tm_list`,{"mapped_type": type,"mapped_category":category})
       .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })
        
    } catch (error) {
        console.log(error);
    }
}

export const getMds=async(type,category,setData)=>{
    try {
        await axios.post(`${url}/map/get_mds_list`,{"mapped_type": type,"mapped_category":category})
       .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })
        
    } catch (error) {
        console.log(error);
    }
}

export const getSH=async(category,type,setData)=>{
    try {
        await axios.post(`${url}/map/get_sh_list`,{mapped_category:category,mapped_type:type},
            {
                headers:{
                    'Content-Type':'application/json'
                }
            }
        )
       .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })
        
    } catch (error) {
        console.log(error);
    }
}

export const getRm=async(setData)=>{
    try {
        await axios.get(`${url}/map/get_sh_list`)
       .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })
        
    } catch (error) {
        console.log(error);
    }
}

export const postMappingRequest=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/agent_with_ds`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })
        
    } catch (error) {
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const UpdateAgentDsMapping=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/agent_with_ds/update`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })       
    } catch (error) {
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const postDsMdsRequest=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/ds_with_mds`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })
       
    } catch (error) {
        // setErrMessage(error.response.data.error)
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const UpdateDsMdsMapping=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/ds_with_mds/update`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })
        
    } catch (error) {
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const UpdateTmMdsMapping=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/mds_with_tm/update`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })        
    } catch (error) {
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const postMdsTmRequest=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/mds_with_tm`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })       
    } catch (error) {
        // setErrMessage(error.response.data.error)
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const postDsTmRequest=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/ds_with_tm`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })
        
    } catch (error) {
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const UpdateDsTmMapping=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/ds_with_tm/update`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })
        
    } catch (error) {
        console.log(error);
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}

export const postTmShRequest=async(data,handleSuccess,handleError,setErrMessage,handleBack)=>{
    try {
        await axios.post(`${url}/map/tm_with_sh`,data)
       .then((res) => {
        if(res.status===200){
            handleSuccess()
            setTimeout(()=>{
                handleBack()
                window.location.reload()
            },3000)
        }
       })        
    } catch (error) {
        if(error.response)
        setErrMessage(error.response.data.error)
        handleError()
        // console.log(error);
    }
}


export const getDsByPincode=async(setData,pincode)=>{
try {
    await axios.get(`${url}/map/get_ds_list`,{
        headers:{
            Authorization:`Bearer ${sessionStorage.getItem('token')}`,
            
        },
        params: {
            pincode:pincode
        }
    })
    .then((res) => {
        if(res.status===200){
            setData(res.data)
        }
       })
    
} catch (error) {
    console.log(error);
}
}